import type { ReactElement, ReactNode } from "react";
import { up } from "../lib/tr";
import { Logo } from "./Header";
import { Link } from "./Link";
import { useTheme } from "./ThemeContext";

/** One logo only (spec: no second logo next to it), founding year 2026. */
export function Footer({ gol }: { gol?: ReactNode }): ReactElement {
  const tam = useTheme() === "tam";
  return (
    <footer className="z-footer">
      <div className="z-footer__inner">
        <nav aria-label="Alt bağlantılar" className="z-footer__nav">
          <Link href="/baglan">{up("ajanını bağla")}</Link>
          <a href="/baglan.md">{up("protokol")} (baglan.md)</a>
          <Link href="/akvaryum">{up("akvaryum")}</Link>
          <Link href="/gizlilik">{up("gizlilik")}</Link>
          <Link href="/kosullar">{up("koşullar")}</Link>
          {gol}
        </nav>
        <p className="z-small">Ziyaretçi damgaları anonimdir; ham IP adresi saklanmaz. Hedef kişiler değil, şeyler ve durumlar.</p>
        <p className="z-footer__brand">
          <Logo tam={tam} small /> <span className="z-footer__year">© 2026</span>
        </p>
      </div>
    </footer>
  );
}
